import React from 'react';
import PropTypes from 'prop-types';
import Layout from '../layouts/application';
import { ThemeProvider } from '@mui/material/styles';
import { themeAttuned } from '../../constants/theme';
import { ConfirmDialogProvider } from '../../components/modals/confirm_dialog';
import { Paper } from '@mui/material';
import SurveyCollectionsNav from '../../components/survey_collections/nav';
import SurveyCollectionsTable from '../../components/survey_collections/table';

const Container = (props) => {
  const { org_id, survey_collections, base_url, links, permission_props, spark_report_url, spark_audiences } = props;
  return (
    <>
      <SurveyCollectionsNav links={links} permissionProps={permission_props} activeTab="data_analysis" />
      <Paper className="p-3 mt-4">
        <SurveyCollectionsTable
          survey_collections={survey_collections}
          permissionProps={permission_props}
          baseUrl={base_url}
          sparkReportUrl={spark_report_url}
          sparkAudiences={spark_audiences}
          view="data_analysis"
        />
      </Paper>
    </>
  );
};

Container.propTypes = {
  org_id: PropTypes.number.isRequired,
  survey_collections: PropTypes.array.isRequired,
  base_url: PropTypes.string.isRequired,
  links: PropTypes.object.isRequired,
  // The Spark dashboard's Overview tab, where a SPARK row's "View" goes instead of the Tableau
  // `data_analysis_show` view. Absent when the dashboard's own gate would refuse this user (see
  // SurveyCollectionsController#spark_report_url), and every row then keeps the legacy view.
  spark_report_url: PropTypes.string,
  // The audiences the org has published Spark results for (D-130). A Student / Family row's "View"
  // is enabled only when its audience is listed. Absent with `spark_report_url`.
  spark_audiences: PropTypes.arrayOf(PropTypes.string),
};

export default (props, railsContext) => {
  return () => (
    <Layout railsContext={railsContext}>
      <ThemeProvider theme={themeAttuned}>
        <ConfirmDialogProvider>
          <Container {...props} />
        </ConfirmDialogProvider>
      </ThemeProvider>
    </Layout>
  );
};
